import PropTypes from "prop-types";
import React, { forwardRef } from "react";

const Input = forwardRef((props, ref) => {
  return (
    <input
      {...props}
      ref={ref}
      className={`helix-text-input ${
        props.large ? "helix-text-input-input--large" : ""
      }`}
    />
  );
});

Input.propTypes = {
  large: PropTypes.bool
};

export default Input;
